import { IAnalyticsEvent } from "../events/types";
import { IAnalyticsTransport } from "../interfaces";

export class GoogleTagManagerTransport implements IAnalyticsTransport {
  constructor(private readonly pushMessage: (event: unknown) => void) {}
  public async logEvent(event: IAnalyticsEvent): Promise<void> {
    this.pushMessage(event.toGoogleTagManagerEvent());
  }
}
